// src/components/TunnelList.js
import React from 'react';
import TunnelItem from './TunnelItem';
import { useTunnelContext } from '../TunnelContext';
import './TunnelList.css';

const TunnelList = () => {
  const context = useTunnelContext();
  //useEffect(() => {
  //  console.log('TunnelList - Full context:', context);
  //}, [context]);

  const { 
    tunnelInfos, 
    tunnelFees, 
    tunnelDistances, 
    tunnelIcons,  
    sortedTunnelDistances 
  } = context;

  return (
    <div id="tunnelList">
      {sortedTunnelDistances.map((item) => {
        const abbr = typeof item === 'string' ? item : item.abbr;
        
        const tunnel = tunnelInfos.find(info => info.abbr === abbr);
        const fee = tunnelFees.find(f => f.abbr === abbr)?.fee;
        const distance = tunnelDistances.find(d => d.abbr === abbr)?.distance;
        const icon = tunnelIcons.find(i => i.abbr === abbr)?.svg;

        return (
          <div
            key={abbr}
            className="tunnel-item"
          >
          <TunnelItem
            key={abbr}
            tunnel={tunnel}
            fee={fee}
            distance={distance}
            icon={icon}
          />
          </div>
        );


      })}
    </div>
  );

};

export default TunnelList;
